// https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=45861836#id-%E6%B5%81%E6%9C%8D%E5%8A%A1%E6%8E%A5%E5%8F%A3-%E7%94%A8%E6%88%B7%E9%80%80%E8%AE%A2%E7%AE%A1%E7%90%86%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3

export const HOST = ['https://test-ms-public.ihuhoo.com', 'https://ms-public.tradeup.com'];
export const API = {
    // 查询用户设置
    getMessageSetting: '/stream/public/message/settings',
    // 提交用户设置
    submitMessageSetting: '/stream/public/message/settings',
    /**
     * 接口文档 https://tigertech.feishu.cn/wiki/wikcnC19SYVo1uv7d1S2gx4oVlb
     * @RD chen bin
     */
    invitation: {
        reset: '/api/polaris/v1/user_channel/invitation'
    }
};

export function bindCG() {
    const cfg = CG_API['bi-stream']?.TBUS;

    if (cfg) {
        HOST.fill(cfg);
    }
}
